import { cloneDeep } from 'lodash';
import UsersActions from '../actions/UsersCRUDActions';
import Actions from '../actions/actions';
import {
  setBusy,
  retrievedAllPagination,
  retrieved,
  setUnBusy,
  update,
} from './common/commonReducers';

const initialState = {
  busy: false,
  entities: [],
  entitiesFb: [],
  currentUser: {},
  pagination: {},
};

export default function companyUsers(state = initialState, action) {
  switch (action.type) {
    case UsersActions.busyAction:
      return setBusy(state);
    case UsersActions.unbusyAction:
      return setUnBusy(state);
    case UsersActions.updateAction:
      return update(state, action);
    case UsersActions.retrievedAllAction:
      return retrievedAllPagination(state, action);
    case UsersActions.retrievedByIdAction: {
      const { user } = action;
      const updatedEntities = state.entities.filter(e => e.id !== user.id);
      return {
        ...state,
        busy: false,
        entities: [...updatedEntities, user],
        currentUser: user,
      };
    }
    case UsersActions.retriveAllByFacebookPageAction: {
      const { users } = action;
      const newState = cloneDeep(state);
      newState.entitiesFb = users;
      newState.busy = false;
      return newState;
    }
    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
}
